import { Link } from 'react-router-dom';
import { cn } from '@shared/lib';
import { CURRENT_VERSION, useThemeAsset } from '@shared/configs';
import { MobileSidebar } from './MobileNav';
import { UserNav } from './UserNav';
import EFL_TEXT from '@shared/assets/pictures/efl_text_font.png';
import WHITE_EFL_TEXT from '@shared/assets/pictures/efl-text-white.png';
import HALF_LOGO from '@shared/assets/pictures/eclipse_fitness_lv.png';
import { VersioningBanner } from '@widgets/versioning-banner';
import { useAuth } from '@entities/auth';

export const Header = () => {
  const { user } = useAuth();
  const THEME_LOGO = useThemeAsset(EFL_TEXT, WHITE_EFL_TEXT);

  const homeLink =
    user?.role !== 'member' ? `${user?.role}/dashboard` : `/dashboard`;

  return (
    <header className="sticky left-0 right-0 top-0 z-20 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <nav className="flex h-12 items-center justify-between px-4">
        <Link
          to={homeLink}
          className="hidden items-center justify-between gap-2 md:flex"
        >
          <img src={HALF_LOGO} alt="" width={45} />
          <img src={THEME_LOGO} height={55} width={175} />
        </Link>
        <div className={cn('block md:!hidden')}>
          <MobileSidebar
            role={user?.role ?? 'member'}
            stripe_link={
              user && (user.role === 'admin' || user.role === 'trainer')
                ? user.stripe_link
                : undefined
            }
          />
        </div>
        <div className="flex items-center justify-between gap-2 md:px-6">
          <VersioningBanner version={CURRENT_VERSION} />
          {user && <UserNav user={user} />}
        </div>
      </nav>
    </header>
  );
};

/*
sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"

*/
